import { cn } from "../../lib/utils";
import { Badge } from "./Badge";

type BookingMode = "instant" | "request";

/**
 * Marks a vehicle or category the renter books by REQUEST: the fleet approves
 * it before any charge, unlike an instant booking. Light-only by design.
 */
export function RequestToBookBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "border-amber-300 bg-amber-50 text-amber-800 whitespace-nowrap",
        className,
      )}
    >
      Request to Book
    </Badge>
  );
}

/**
 * A category is a Request to Book category only when its own mode is
 * `request` AND none of its vehicles overrides that back to `instant`
 * (`booking_mode_override`, the vehicle's own setting; `null` inherits).
 * Anything else would promise an approval step some of its vehicles skip.
 */
export function isRequestToBookCategory(category: {
  booking_mode?: BookingMode | null;
  vehicles?: Array<{ booking_mode_override?: BookingMode | null }> | null;
}): boolean {
  if (category.booking_mode !== "request") return false;

  return !(category.vehicles ?? []).some(
    (vehicle) => vehicle.booking_mode_override === "instant",
  );
}
